import { createUseStyles } from 'react-jss';
import { ThemeProps } from '@styles/theme';

import { flex } from '@resources/mixins';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    expanded: {},
    notActive: {},
    mainWrapper: {
        height: '100%',
        [theme.down('mobile')]: {
            height: 'auto',
        },
        padding: `${theme.spacing(4)}px ${theme.spacing(8)}px ${theme.spacing(8)}px`,
        [theme.down('desktop')]: {
            padding: `${theme.spacing(3)}px ${theme.spacing(5)}px ${theme.spacing(5)}px`,
        },
        [theme.down('tablet')]: {
            padding: theme.spacing(4),
        },
    },
    body: {
        display: 'flex',
        padding: `${theme.spacing(4)} ${theme.spacing(4)} ${theme.spacing(4)} ${theme.spacing(10)}`,
    },
    noInfo: {
        color: theme.colors.grey_text,
    },
    tableActions: {
        ...flex('row', 'space-between', 'center'),
        padding: `${0}px ${theme.spacing(4)}`,
        marginBottom: theme.spacing(3),
        gap: theme.spacing(1.5),
        flexWrap: 'nowrap',
        [theme.down('tablet')]: {
            padding: 0,
            flexWrap: 'wrap',
        },
    },
    summaryPanel: {
        display: 'flex',
        flex: '1 1 26rem',
        maxWidth: '45rem',
        minWidth: 0,
        marginBottom: 0,
        [theme.down('tablet')]: {
            width: '100%',
        },
    },
    filters: {
        display: 'flex',
        alignItems: 'center',
        flex: '0 1 auto',
        justifyContent: 'flex-end',
        [theme.down('tablet')]: {
            width: '100%',
            justifyContent: 'flex-start',
        },
    },
    invite: {
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
    },
    button: {
        border: 'none',
        background: 'none',
        outline: 'none',
        padding: 0,
        minHeight: 40,
        minWidth: 40,

        marginLeft: 0,
        '&:disabled': {
            opacity: .3,
        },

        '&:hover': {
            background: theme.colors.icon_background,
            borderRadius: theme.radius / 2,
            cursor: 'pointer',
        },
    },
    h4: {
        fontFamily: theme.font.secondary,
        fontSize: 20,
        lineHeight: 1.4,
        fontWeight: 'normal',
        color: theme.colors.black,
    },
    searchWrapper: {
        width: 260,
        marginRight: 0,
        [theme.down('tablet')]: {
            width: 'min(100%, 360px)',
        },
    },
    nameWrapper: {
        ...flex('row', 'flex-start', 'center'),
        minWidth: 0,
    },
    expandIcon: {
        transformOrigin: 'center',
        transition: 'transform .2s ease',
        transform: 'rotate(90deg)',

        '&$expanded': {
            transform: 'rotate(-90deg)',
        },
    },
    licenseName: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    bodySubComponent: {
        display: 'flex',
        flexDirection: 'column',
        padding: `${theme.spacing(4)} ${theme.spacing(4)} ${theme.spacing(4)} ${theme.spacing(10)}`,
    },
    descriptionWrapper: {
        padding: `${0}px ${theme.spacing(2)} ${theme.spacing(4)} ${theme.spacing(2)}`,
        flex: '18 0 18%',

    },
    header: {
        color: theme.colors.grey_text,
        fontSize: 16,
        fontFamily: theme.font.secondary,
        lineHeight: 1.25,
        paddingBottom: 10,
    },
    text: {
        color: theme.colors.black,
        lineHeight: 1.5,
        fontSize: 16,
        fontFamily: theme.font.primary,
        [theme.down('tablet')]: {
            fontSize: 14,
        },
    },
    placeholder: {
        width: '40px',
        display: 'inline-block',
    },
    actionWrapper: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: theme.spacing(1),
        minWidth: 96,
    },
    addIcon: {
        color: theme.colors.violet_primary,
        cursor: 'pointer',
        marginLeft: theme.spacing(3),
    },
    withEllipsis: {
        whiteSpace: 'ellipsis',
    },
}));
